var _$angular_136 = createModuleFactory(function (module, exports) {
_$angular_135,module.exports=angular;

});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImluZGV4LmpzIl0sIm5hbWVzIjpbInJlcXVpcmUiLCJtb2R1bGUiLCJleHBvcnRzIiwiYW5ndWxhciJdLCJtYXBwaW5ncyI6IjtBQUFBQSxhQUFRLENBQ1JDLE1BQUFBLENBQU9DLE9BQUFBLENBQVVDLE9BQUFBLENBQUFBIiwic291cmNlc0NvbnRlbnQiOltudWxsXX0=